import { createFormAction } from 'redux-form-saga';
import * as cosAnnexeFormTypes from './cosAnnexeFormTypes';

export const submitCosAnnexeForm = createFormAction(cosAnnexeFormTypes.SUBMIT_COSANNEXE_FORM);
